<!--
 * @Description:
 * @Author: LXG
 * @Date: 2022-01-27
 * @Editors: LXG
 * @LastEditTime: 2022-01-28
-->
<template>
  <div>
    <div class="background">
      <div class="header">
        <div class="header-wrap">
          <img
            src="@/assets/images/mobile/return.png"
            class="header-img"
            @click="goBack"
          />
          <div v-if="name.length>9"  style="text-align: center;color: #ffffff;font-family: 'Microsoft YaHei';letter-spacing: 1.5px;font-size: 16px">{{name.substr(0,10)}}...</div>
          <div v-else  style="text-align: center;color: #ffffff;font-family: 'Microsoft YaHei';letter-spacing: 1.5px;font-size: 16px">{{name}}</div>
          <div></div>
          <div></div>
        </div>
      </div>
<!--      <img class="img1" src="../../assets/images/mobile/newbj.png" />-->
      <div class="login-content">
        <div class="login-right">
          <div class="form-content">
            <div v-html="content" class="detailcontent"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mobilepolicydetail",
  data() {
    return {
      content: "",
      name:"",
    };
  },
  methods: {
    goBack() {
      this.$router.replace({
        path: "/suqiuMobile",
      });
    },
    initData() {
      let url = "/dev-api/qymgg/queryGgSbjContentByid";
      this.$httpApi.post(url, { ggId: this.ggid }).then((r) => {
        if (r.code == 200) {
          this.content = r.data.content;
          this.name = r.data.name
        }
      });
    },
  },
  created() {
    this.ggid = this.$route.query.id;
    this.initData();
  },
  mounted() {},
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
@import "@/styles/com/theme.scss";

.background {
  background-color: white;
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  .header {
    z-index: 200;
    width: 100%;
    height: 60px;
    position: fixed;
    top: 0;

    .header-wrap {
      flex: 1;
      width: 100%;
      height: 100%;
      //background: #FFFFFF;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      background-color: #46b148;
      color: #ffffff;

      .header-img {
        width: 20px;
        height: 20px;
      }
    }
  }

  .img1 {
    width: 100vw;
    height: 100vh;
    // z-index: 101;
    position: absolute;
  }

  .img2 {
    width: 27rem;
    margin-left: -3.5rem;
    height: 471.1px;
    z-index: 101;
    position: absolute;
    top: 75%;
    margin-top: -336.5px;
  }
}


.login-content {
  position: absolute;
  top: 45%;
  z-index: 102;
  -webkit-transform: translateY(-30%);
  -moz-transform: translateY(-30%);
  -o-transform: translateY(-30%);
  -ms-transform: translateY(-30%);
  transform: translateY(-30%);
}


.form-content {
  width: 23.5rem;
  height: 136vh;
  padding: 20px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 3px 15px rgba($color: rgb(0, 0, 0), $alpha: 0.2);
  position: relative;
  margin-top: 40px;
  ::v-deep .detailcontent {
    height: 100vh;
    overflow: hidden;
    overflow-y: scroll;
    p{
    img{
        width:80vw;
    }
    }
  }
}
</style>
